<template>
  <svg
    :class="size"
    viewBox="0 0 46 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_5173_48615)">
      <rect
        x="4.72266"
        y="1.93652"
        width="37.3399"
        height="37.3399"
        rx="5"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0682 16V16C32.0777 15.9303 32.0777 15.8597 32.0682 15.79C32.0595 15.7313 32.0427 15.6741 32.0182 15.62V15.62C31.9918 15.5711 31.9617 15.5243 31.9282 15.48C31.8901 15.4168 31.843 15.3595 31.7882 15.31L31.6682 15.24C31.6105 15.197 31.5464 15.1632 31.4782 15.14H31.2782V15.14C31.2173 15.081 31.1461 15.0336 31.0682 15H26.0682V15C25.5159 15 25.0682 15.4477 25.0682 16C25.0682 16.5523 25.5159 17 26.0682 17H28.8982L24.8982 21.71L20.5782 19.14C20.1555 18.8886 19.6127 18.9819 19.2982 19.36L14.2982 25.36H14.2982C13.9446 25.7843 14.002 26.4149 14.4263 26.7684C14.4269 26.7689 14.4275 26.7695 14.4282 26.77C14.6081 26.9191 14.8345 27.0005 15.0682 27C15.3656 27.0005 15.6478 26.8685 15.8382 26.64L20.2882 21.3L24.5582 23.86C24.9763 24.108 25.5122 24.0194 25.8282 23.65L30.0682 18.7V21C30.0682 21.5523 30.5159 22 31.0682 22C31.6205 22 32.0682 21.5523 32.0682 21V16V16Z"
        :fill="$primaryColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_5173_48615"
        x="0.988669"
        y="0.0695297"
        width="44.8078"
        height="44.8078"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.86699" />
        <feGaussianBlur stdDeviation="1.86699" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.00784314 0 0 0 0 0.027451 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5173_48615"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.466748" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.00784314 0 0 0 0 0.027451 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_5173_48615"
          result="effect2_dropShadow_5173_48615"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_5173_48615"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-10 w-10'
    }
  }
}
</script>

<style></style>
